module.exports = __webpack_public_path__ + "static/media/breakfastCerealMixes.c1796a29.webp";